export class CurrentUSer{
    _fbName:string;
    _pictureUrl:string;
    _currentUser:string;
    _wins:number;
    _games:number;
     _lives:number;
    
    _paymentRequestId:number = 0;
    _paymentRequestIdInUse:number = 0;
    
    _permission:Map<string, string>;
    _coins:number = 0;

    constructor(fbName:string, pictureUrl:string, currentUser:string)
    {
        this._currentUser = currentUser;
        this._fbName = fbName;
        this._pictureUrl = pictureUrl;
        this._permission = new Map();
        
        this._wins = 0;
        this._games = 0;
        this._lives = 0;
    }

    hasPermission( permissionName:string ) : Boolean {
        return this._permission[ permissionName ] != null;
    }
    addPermission( permissionName:string ) : void {
        if ( this._permission[ permissionName ] != null ) {
                throw new Error( "User have a permission: " + permissionName );
        }
        this._permission[ permissionName ] = permissionName;
    }
    removePermission( permissionName:string ) : void {
        if ( this._permission[ permissionName ] == null ) {
                throw new Error( "User doesn't have a permission: " + permissionName );
        }
        delete this._permission[ permissionName ]; 
    }
    
    addLife( expectedLife:number ) : void {
        this._lives++;
        if ( expectedLife != this._lives ) {
            throw new Error("Bad lives and expected lives: " + this._lives + " - " + expectedLife);
        }
    }
    
    beat(currentLives:number):void {
        this._lives--;
        if (currentLives != this._lives) {
            throw new Error("Bad lives and expected lives: " + this._lives + " - " + currentLives);
        }
    }
    setPaymentRequestIdInUse(paymentRequestIdInUse:number):void
    {
        this._paymentRequestIdInUse = paymentRequestIdInUse;
    }
    
    getPaymentRequestIdInUse():number
    {
        return this._paymentRequestIdInUse;
    }
    
    setPaymentRequestId(paymentRequestId:number):void
    {
        this._paymentRequestId = paymentRequestId;
    }
    
    getPaymentRequestId():number
    {
        return this._paymentRequestId;
    }
    
    setCoins(coins:number):void
    {
        this._coins = coins;
    }
    
    getCoins():number
    {
        return this._coins;
    }
    
    setLives(lives:number):void
    {
        this._lives = lives;
    }
    
    getLives():number
    {
        return this._lives;
    }
    
    setWins(wins:number):void
    {
        this._wins = wins;
    }
    
    getWins():number
    {
        return this._wins;
    }
    setGames(games:number):void
    {
        this._games = games;
    }
    
    getGames():number
    {
        return this._games;
    }
    
    
    getCurrentUser():string
    {
        return this._currentUser;
    }
    
    getPpictureUrl():string
    {
        return this._pictureUrl;
    }
    
    getFbName():string
    {
        return this._fbName;
    }
                    
    isConnected():boolean
    {
        return true;
    }
}